import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';

export default Helper.extend({
  formatAmountService: service(),

  /*
    namedArgs
      - round
        - round to the nearest dollar
        - default is false
      - removeNoCents
       - If there are no cents, then remove them
       - default is false
  */
  compute(args, namedArgs) {
    let val = args[0];
    if (namedArgs.round) {
      val = Math.round(Number(val), 0);
    }
    let formatVal = this.formatAmountService.format(val, {
      roundToDollar: namedArgs.round || false,
      removeNoCents: namedArgs.removeNoCents || false,
    });
    if (Number(val) < 0) {
      formatVal = `<span class='text-danger'>${formatVal}</span>`;
    }
    return htmlSafe(formatVal);
  },
});
